import React from 'react';
import { MenuItem } from '../../interfaces/menu-item';
import NavItem from '../atoms/NavItem';

interface NavProps {
  items: MenuItem[];
}

const Nav: React.FC<NavProps> = ({ items }) => (
  <nav className="hidden lg:block">
    <ul className="flex items-center space-x-16">
      {items.map((item) => (
        <li key={item.label}>
          <NavItem item={item} />
        </li>
      ))}
    </ul>
  </nav>
);

export default Nav;
